import axios, { type AxiosError } from 'axios';
import type { ErrorEnvelop } from '../hooks';
import { apiLogger } from '../logger/loggers';
import { getTransactionContext } from '../transaction';
import { getApiErrorMessage, getApiRequestId } from '../utils/transform';

export const setupApiErrorInterceptor = () => {
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (axios.isCancel(error)) {
        return Promise.reject(error);
      }

      const axiosError = error as AxiosError<ErrorEnvelop>;

      try {
        apiLogger.error(
          {
            ...getTransactionContext(),
            url: axiosError.config?.url,
            method: axiosError.config?.method,
            status: axiosError.response?.status,
            requestId: getApiRequestId(axiosError),
            error: getApiErrorMessage(axiosError),
          },
          'API request failed',
        );
      } catch {
        // never let logging corrupt error propagation to the caller
      }

      return Promise.reject(error);
    },
  );
};
